import { api } from "./client";
import type { Balance, IdleStatus, ShopItem } from "../types";

interface CollectIdleResponse {
  collected_gold: number;
  new_gold_balance: number;
  idle: IdleStatus;
}

interface ShopBuyResponse {
  success: boolean;
  item_id: string;
  quantity: number;
  remaining_gold: number;
  remaining_diamonds: number;
}

export const economyApi = {
  getBalance: () => api.get<Balance>("/balance"),

  collectIdle: () => api.post<CollectIdleResponse>("/economy/collect-idle"),

  getShop: () => api.get<ShopItem[]>("/shop"),

  buyItem: (item_id: string, quantity = 1) =>
    api.post<ShopBuyResponse>("/shop/buy", { item_id, quantity }),
};
